var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./~/react-string-replace/~/lodash/_Symbol.js
// module id = 185
// module chunks = 0